import CompaniesTable from './CompaniesTable.container';

export default CompaniesTable;
